import * as React from "react";
import ModalPopup from "../commons/components/modal/ModalPopup";
import Form from "../commons/components/form/Form";
import InputState from "../commons/model/form/InputState";
import MultiSelectCheckboxInput from "../commons/components/form/input/MultiSelectCheckboxInput";
import TextInput from "../commons/components/form/input/TextInput";
import { minChecked, required } from "../commons/model/form/Validators";
import sfetch from "../commons/utils/super-fetch";
import "./ModalAddTeam.scss";
import SelectableOption from "../commons/model/SelectableOption";

interface ModalAddTeamProps {
  countries: SelectableOption[];
  close: (reload: boolean) => void;
}

interface ModalAddTeamState {
  globalErrorMsg?: string;
}

// LongTermFix sjahan 19/06/20: Must be merged with ModalModifyTeam
export default class ModalAddTeam extends React.Component<ModalAddTeamProps, ModalAddTeamState> {
  constructor(props: ModalAddTeamProps) {
    super(props);
    this.confirm = this.confirm.bind(this);
    this.state = {};
  }

  private confirm(form: { [key: string]: InputState }): Promise<void> {
    const payload = {};
    payload["name"] = form["teamName"].value;
    payload["countries"] = form["countries"].value;

    return sfetch("/internal-api/v1/customer-support-teams", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => this.props.close(true))
      .catch((response) => {
        if (response.status == 400) {
          this.setState({
            globalErrorMsg: i18n["Page.CustomerSupport.Error.BadRequest"],
          });
        } else if (response.status == 409) {
          form["teamName"].status.setError(i18n["Page.CustomerSupport.Error.NameConflict"]);
        }
        throw response;
      });
  }

  render() {
    return (
      <>
        <ModalPopup closeModal={() => this.props.close(false)} id="modal-add-team">
          <div className="title">{i18n["Page.CustomerSupport.AddTeam.Title"]}</div>
          <Form
            titleLabel={i18n["Page.CustomerSupport.AddTeam.Title"]}
            submitLabel={i18n["Page.CustomerSupport.AddTeam.Submit"]}
            submit={this.confirm}
            generalErrorMsg={this.state.globalErrorMsg}
          >
            <TextInput
              name="teamName"
              label={i18n["Page.CustomerSupport.Name"]}
              placeholder={i18n["Page.CustomerSupport.NamePlaceHolder"]}
              validators={[required()]}
            />
            <MultiSelectCheckboxInput
              name="countries"
              label={i18n["Page.CustomerSupport.Countries"]}
              options={this.props.countries}
              validators={[minChecked(i18n["Form.Error.AtLeastOneValueIsRequired"], 1)]}
            />
          </Form>
        </ModalPopup>
      </>
    );
  }
}
